import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconStickerFilled = createSVG({
    children: (jsxs(Fragment, { children: [jsx("path", { d: "M5.999 2a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h5.608q.16 0 .318-.013a6.6 6.6 0 0 1-1.43-4.112q0-.597.102-1.165A4.75 4.75 0 0 1 7.1 14.375a.75.75 0 0 1 1.299-.751 3.25 3.25 0 0 0 2.639 1.621 6.626 6.626 0 0 1 10.864-1.957q.098-.432.098-.881V6a4 4 0 0 0-4-4zm4 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0m6 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" }), jsx("path", { d: "M21.213 14.789a4 4 0 0 1-.58.628l-6.392 5.593a4 4 0 0 1-.727.506 5.125 5.125 0 1 1 7.698-6.727z" })] })),
});

export { IconStickerFilled };
